import { type AlgoliaBaseProduct } from "@lib/wrappers/algolia/types";
import { AlgoliaRecommendModel } from "./types";

export const ALGOLIA_AI_CHAT_AGENT_ID = process.env.NEXT_PUBLIC_ALGOLIA_AI_CHAT_AGENT_ID || "";

export const DEFAULT_ATTRIBUTES_TO_RETRIEVE: (keyof AlgoliaBaseProduct)[] = [
    "articleNumber",
    "productColors",
    "objectID",
    "colorCode",
    "categories",
    "hasDiscount",
    "eaBadge",
    "eccoClubBadge",
    "image",
    "images",
    "imageLabel",
    "hasStock",
    "name",
    "occasion",
    "listPriceRaw",
    "priceRaw",
    "lowestPriceRaw",
    "discountPercentageLowestPrice",
    "priceWithDiscount",
    "priceWithoutDiscount",
    "variants",
    "backgroundColor",
    "discountPercentage",
    "badges",
    "listPrice",
    "bestseller",
    "onlineExclusive",
    "group",
    "collectionClass",
    "collectionType",
    "dominantColor",
    "pageTitle",
    "hasEccoClub",
];

export const AlgoliaAssistiveMessages: Record<AlgoliaRecommendModel, string> = {
    [AlgoliaRecommendModel.RELATED_PRODUCTS]:
        "These are products we found similar to the product you are looking at",
    [AlgoliaRecommendModel.BOUGHT_TOGETHER]:
        "These are products that have been purchased by other people together with the product you are looking at",
    [AlgoliaRecommendModel.LOOKING_SIMILAR]:
        "These are products we found that look similar to the product you are looking at",
    [AlgoliaRecommendModel.TRENDING_ITEMS]:
        "These are trending products based on recent popularity",
};

export const RecommendationListLabels: Record<
    AlgoliaRecommendModel,
    { listName: string; listId: string }
> = {
    [AlgoliaRecommendModel.RELATED_PRODUCTS]: {
        listName: "PDP related products",
        listId: "pdp_related_products",
    },
    [AlgoliaRecommendModel.LOOKING_SIMILAR]: {
        listName: "PDP looking similar",
        listId: "pdp_looking_similar",
    },
    [AlgoliaRecommendModel.BOUGHT_TOGETHER]: {
        listName: "PDP bought together",
        listId: "pdp_bought_together",
    },
    [AlgoliaRecommendModel.TRENDING_ITEMS]: {
        listName: "Search trending items",
        listId: "search_trending_items",
    },
};
